(() => {
  const dialog = document.querySelector('#NamiBag');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const strings = JSON.parse(dialog.querySelector('[data-bag-strings]').textContent);
  const items = dialog.querySelector('[data-bag-items]');
  const status = dialog.querySelector('[data-bag-status]');
  const error = dialog.querySelector('[data-bag-error]');
  const footer = dialog.querySelector('[data-bag-footer]');
  const checkout = dialog.querySelector('[name="checkout"]');
  const closeButton = dialog.querySelector('.namiBag__close');
  const panel = dialog.querySelector('.namiBag__panel');
  const template = dialog.querySelector('[data-bag-item-template]');
  let busy = false;
  let requestId = 0;
  let motionId = 0;
  let openingFrame;
  let closing = false;
  let opener;
  let previousOverflow;
  let previousGutter;
  let hasItems = false;

  const setBusy = (value) => {
    busy = value;
    items.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('.namiBag__remove').forEach(button => { button.disabled = value; });
    checkout.disabled = value || !hasItems;
  };
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, minimumFractionDigits: 2,
  }).format(amount / 100);
  const safeUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  };
  const render = (cart) => {
    const fragment = document.createDocumentFragment();
    cart.items.forEach(item => {
      const row = template.content.cloneNode(true);
      const image = row.querySelector('img');
      const imageUrl = safeUrl(item.featured_image?.url || item.image);
      if (imageUrl && (item.featured_image?.url || item.image)) image.src = imageUrl;
      else image.hidden = true;
      image.alt = item.featured_image?.alt || item.product_title;
      const title = row.querySelector('.namiBag__title');
      title.textContent = item.product_title;
      title.href = safeUrl(item.url);
      row.querySelector('.namiBag__price').textContent = money(item.final_line_price, cart.currency);
      const options = row.querySelector('.namiBag__options');
      (item.options_with_values || []).forEach(option => {
        if (option.value === 'Default Title') return;
        const text = document.createElement('p');
        text.textContent = `${option.name}: ${option.value}`;
        options.append(text);
      });
      if (item.selling_plan_allocation) {
        const plan = document.createElement('p');
        plan.textContent = item.selling_plan_allocation.selling_plan.name;
        options.append(plan);
      }
      row.querySelector('.namiBag__quantity span').textContent = item.quantity;
      row.querySelector('.namiBag__remove').dataset.lineKey = item.key;
      fragment.append(row);
    });
    items.replaceChildren(fragment);
    hasItems = cart.item_count > 0;
    dialog.querySelector('[data-bag-empty]').hidden = hasItems;
    footer.hidden = !hasItems;
    dialog.querySelector('[data-bag-total]').textContent = money(cart.total_price, cart.currency);
    document.querySelectorAll('[data-bag-count], [data-drawer-count]').forEach(el => { el.textContent = cart.item_count; });
    error.hidden = true;
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options,
      headers: { Accept: 'application/json', ...options.headers }, signal: AbortSignal.timeout(15000) });
    const cart = await response.json();
    if (!response.ok || !Array.isArray(cart.items)) throw new Error('Cart request failed');
    return cart;
  };
  const refresh = async (message = '') => {
    const id = ++requestId;
    setBusy(true);
    error.hidden = true;
    status.textContent = strings.loading;
    try {
      const cart = await request(`${dialog.dataset.cartUrl}.js`);
      if (id !== requestId) return;
      render(cart);
      status.textContent = message;
    } catch {
      if (id !== requestId) return;
      status.textContent = message;
      error.hidden = false;
      hasItems = false;
    } finally {
      if (id === requestId) setBusy(false);
    }
  };
  const open = (trigger, instant = false, message = '') => {
    const id = ++motionId;
    cancelAnimationFrame(openingFrame);
    closing = false;
    dialog.toggleAttribute('data-instant', instant);
    const wasOpen = dialog.open;
    if (!dialog.open) {
      opener = trigger || document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      previousGutter = document.documentElement.style.scrollbarGutter;
      if (window.innerWidth > document.documentElement.clientWidth) {
        document.documentElement.style.scrollbarGutter = 'stable';
      }
      document.documentElement.style.overflow = 'hidden';
      // Lock the viewport only: body overflow creates a new scroll ancestor
      // and sends the sticky PDP details offscreen on a scrolled page.
      dialog.showModal();
      closeButton.focus({ preventScroll: true });
    }
    const reveal = () => {
      if (id === motionId && dialog.open) dialog.setAttribute('data-visible', '');
    };
    if (instant || wasOpen) reveal();
    else openingFrame = requestAnimationFrame(() => {
      openingFrame = requestAnimationFrame(reveal);
    });
    refresh(message);
  };
  const close = (instant = false) => {
    if (!dialog.open || (closing && !instant)) return;
    const id = ++motionId;
    closing = true;
    cancelAnimationFrame(openingFrame);
    dialog.toggleAttribute('data-instant', instant);
    dialog.removeAttribute('data-visible');
    const finish = () => {
      if (id !== motionId) return;
      dialog.close();
      closing = false;
      document.documentElement.style.overflow = previousOverflow || '';
      document.documentElement.style.scrollbarGutter = previousGutter || '';
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    };
    if (instant) finish();
    else Promise.allSettled(panel.getAnimations().map(animation => animation.finished)).then(finish);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname !== dialog.dataset.cartUrl || dialog.contains(link)) return;
    event.preventDefault();
    open(link, event.detail === 0);
  });
  document.addEventListener('nami:cart-added', event => {
    open(event.detail?.trigger, event.detail?.keyboard, strings.added);
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(true); });
  dialog.addEventListener('click', async event => {
    if (event.target === dialog || event.target.closest('[data-bag-close]')) { close(event.detail === 0); return; }
    if (event.target.closest('[data-bag-retry]')) { if (!busy) refresh(); return; }
    const remove = event.target.closest('[data-line-key]');
    if (!remove || busy) return;
    const id = ++requestId;
    setBusy(true);
    error.hidden = true;
    try {
      const cart = await request(dialog.dataset.changeUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.lineKey, quantity: 0 }),
      });
      if (id !== requestId) return;
      render(cart);
      status.textContent = strings.removed;
      closeButton.focus({ preventScroll: true });
    } catch {
      error.hidden = false;
      hasItems = false;
    } finally { if (id === requestId) setBusy(false); }
  });
  dialog.dataset.ready = 'true';
})();
